import { Home, Search } from "lucide-react";
import React from "react";

interface ZipCodeProps {
  visible: boolean;
  zipcode: string;
  setZipcode: (value: string) => void;
  onSearch: () => void;
  onReset: () => void;
}

const ZipcodeInput = (props: ZipCodeProps) => {
  return props.visible ? (
    <div className="space-y-4 mb-8">
      {/* Step heading with icon */}
      <div className="flex items-center gap-2">
        <Home className="h-6 w-6 text-primary" />
        <h3 className="text-xl font-bold text-foreground">Paso 3.</h3>
      </div>

      {/* Instruction text */}
      <p className="text-muted-foreground">Confirma tu código postal:</p>

      {/* Input group with search button */}
      <div className="flex gap-3">
        <div className="flex-1 flex items-center bg-white border border-input rounded-lg px-4 py-3 focus-within:ring-2 focus-within:ring-ring">
          <Home className="h-5 w-5 text-muted-foreground mr-3" />
          <input
            type="text"
            placeholder="#####"
            maxLength={5}
            value={props.zipcode}
            onChange={(event) => props.setZipcode(event.target.value)}
            className="flex-1 outline-none text-foreground bg-transparent"
          />
        </div>
        <button
          onClick={() => props.onSearch()}
          className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-lg px-6 py-3 transition-colors shadow-medium"
        >
          <Search className="h-5 w-5" />
        </button>
      </div>
    </div>
  ) : (
    <div></div>
  );
};

export default ZipcodeInput;
